/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FareTypeResponse
 */
export interface FareTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof FareTypeResponse
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FareTypeResponse
     */
    name?: string | null;
}

export function FareTypeResponseFromJSON(json: any): FareTypeResponse {
    return FareTypeResponseFromJSONTyped(json, false);
}

export function FareTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function FareTypeResponseToJSON(value?: FareTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}


